module.exports = __webpack_public_path__ + "static/Company-Logos-1a8a220e0cef91bb7e267e43aa11732d.png";